var _defs, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.1 14.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-width: 2px;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #1e1a34;\n      }\n\n      .st1 {\n        stroke-miterlimit: 4;\n        stroke-width: 2px;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.1,
    y1: 7,
    x2: 0,
    y2: 7.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7.1,
    x2: 7.2,
    y2: 14.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.506974473f046f285c7ab0533576f86a.svg";
export { ForwardRef as ReactComponent };